// Region Action Types
export const FETCH_REGIONS_REQUEST = "FETCH_REGIONS_REQUEST";
export const FETCH_REGIONS_SUCCESS = "FETCH_REGIONS_SUCCESS";
export const FETCH_REGIONS_FAILURE = "FETCH_REGIONS_FAILURE";

export const DELETE_REGION_REQUEST = "DELETE_REGION_REQUEST";
export const DELETE_REGION_SUCCESS = "DELETE_REGION_SUCCESS";
export const DELETE_REGION_FAILURE = "DELETE_REGION_FAILURE";

export const SAVE_REGION_REQUEST = "SAVE_REGION_REQUEST";
export const SAVE_REGION_SUCCESS = "SAVE_REGION_SUCCESS";
export const SAVE_REGION_FAILURE = "SAVE_REGION_FAILURE";

export const FETCH_REGION_BY_ID_REQUEST = "FETCH_REGION_BY_ID_REQUEST";
export const FETCH_REGION_BY_ID_SUCCESS = "FETCH_REGION_BY_ID_SUCCESS";
export const FETCH_REGION_BY_ID_FAILURE = "FETCH_REGION_BY_ID_FAILURE";

export const UPDATE_REGION_REQUEST = "UPDATE_REGION_REQUEST";
export const UPDATE_REGION_SUCCESS = "UPDATE_REGION_SUCCESS";
export const UPDATE_REGION_FAILURE = "UPDATE_REGION_FAILURE";

export const ACTIVATE_DEACTIVATE_REGION_REQUEST =
  "ACTIVATE_DEACTIVATE_REGION_REQUEST";
export const ACTIVATE_DEACTIVATE_REGION_SUCCESS =
  "ACTIVATE_DEACTIVATE_REGION_SUCCESS";
export const ACTIVATE_DEACTIVATE_REGION_FAILURE =
  "ACTIVATE_DEACTIVATE_REGION_FAILURE";

// National Action Types
export const FETCH_NATIONALS_REQUEST = "FETCH_NATIONALS_REQUEST";
export const FETCH_NATIONALS_SUCCESS = "FETCH_NATIONALS_SUCCESS";
export const FETCH_NATIONALS_FAILURE = "FETCH_NATIONALS_FAILURE";

export const DELETE_NATIONAL_REQUEST = "DELETE_NATIONAL_REQUEST";
export const DELETE_NATIONAL_SUCCESS = "DELETE_NATIONAL_SUCCESS";
export const DELETE_NATIONAL_FAILURE = "DELETE_NATIONAL_FAILURE";

export const SAVE_NATIONAL_REQUEST = "SAVE_NATIONAL_REQUEST";
export const SAVE_NATIONAL_SUCCESS = "SAVE_NATIONAL_SUCCESS";
export const SAVE_NATIONAL_FAILURE = "SAVE_NATIONAL_FAILURE";

export const FETCH_NATIONAL_BY_ID_REQUEST = "FETCH_NATIONAL_BY_ID_REQUEST";
export const FETCH_NATIONAL_BY_ID_SUCCESS = "FETCH_NATIONAL_BY_ID_SUCCESS";
export const FETCH_NATIONAL_BY_ID_FAILURE = "FETCH_NATIONAL_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_NATIONAL_REQUEST =
  "ACTIVATE_DEACTIVATE_NATIONAL_REQUEST";
export const ACTIVATE_DEACTIVATE_NATIONAL_SUCCESS =
  "ACTIVATE_DEACTIVATE_NATIONAL_SUCCESS";
export const ACTIVATE_DEACTIVATE_NATIONAL_FAILURE =
  "ACTIVATE_DEACTIVATE_NATIONAL_FAILURE";

// Worklist Action Types
export const FETCH_WORKLIST_REQUEST = "FETCH_WORKLIST_REQUEST";
export const FETCH_WORKLIST_SUCCESS = "FETCH_WORKLIST_SUCCESS";
export const FETCH_WORKLIST_FAILURE = "FETCH_WORKLIST_FAILURE";

export const DELETE_WORKLIST_REQUEST = "DELETE_WORKLIST_REQUEST";
export const DELETE_WORKLIST_SUCCESS = "DELETE_WORKLIST_SUCCESS";
export const DELETE_WORKLIST_FAILURE = "DELETE_WORKLIST_FAILURE";

export const DROPDOWN_WORKLIST_REQUEST = "DROPDOWN_WORKLIST_REQUEST";
export const DROPDOWN_WORKLIST_SUCCESS = "DROPDOWN_WORKLIST_SUCCESS";
export const DROPDOWN_WORKLIST_FAILURE = "DROPDOWN_WORKLIST_FAILURE";

export const SAVE_WORKLIST_REQUEST = "SAVE_WORKLIST_REQUEST";
export const SAVE_WORKLIST_SUCCESS = "SAVE_WORKLIST_SUCCESS";
export const SAVE_WORKLIST_FAILURE = "SAVE_WORKLIST_FAILURE";

export const FETCH_WORKLIST_BY_ID_REQUEST = "FETCH_WORKLIST_BY_ID_REQUEST";
export const FETCH_WORKLIST_BY_ID_SUCCESS = "FETCH_WORKLIST_BY_ID_SUCCESS";
export const FETCH_WORKLIST_BY_ID_FAILURE = "FETCH_WORKLIST_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_WORKLIST_REQUEST =
  "ACTIVATE_DEACTIVATE_WORKLIST_REQUEST";
export const ACTIVATE_DEACTIVATE_WORKLIST_SUCCESS =
  "ACTIVATE_DEACTIVATE_WORKLIST_SUCCESS";
export const ACTIVATE_DEACTIVATE_WORKLIST_FAILURE =
  "ACTIVATE_DEACTIVATE_WORKLIST_FAILURE";

// Worklist Definition Action Types
export const FETCH_WORKLIST_DEFINITION_REQUEST =
  "FETCH_WORKLIST_DEFINITION_REQUEST";
export const FETCH_WORKLIST_DEFINITION_SUCCESS =
  "FETCH_WORKLIST_DEFINITION_SUCCESS";
export const FETCH_WORKLIST_DEFINITION_FAILURE =
  "FETCH_WORKLIST_DEFINITION_FAILURE";

export const DROPDOWN_WORKLIST_DEFINITION_TYPE_REQUEST =
  "DROPDOWN_WORKLIST_DEFINITION_TYPE_REQUEST";
export const DROPDOWN_WORKLIST_DEFINITION_TYPE_SUCCESS =
  "DROPDOWN_WORKLIST_DEFINITION_TYPE_SUCCESS";
export const DROPDOWN_WORKLIST_DEFINITION_TYPE_FAILURE =
  "DROPDOWN_WORKLIST_DEFINITION_TYPE_FAILURE";

export const DROPDOWN_WORKLIST_DEFINITION_FACILITY_REQUEST =
  "DROPDOWN_WORKLIST_DEFINITION_FACILITY_REQUEST";
export const DROPDOWN_WORKLIST_DEFINITION_FACILITY_SUCCESS =
  "DROPDOWN_WORKLIST_DEFINITION_FACILITY_SUCCESS";
export const DROPDOWN_WORKLIST_DEFINITION_FACILITY_FAILURE =
  "DROPDOWN_WORKLIST_DEFINITION_FACILITY_FAILURE";

export const SAVE_WORKLIST_DEFINITION_REQUEST =
  "SAVE_WORKLIST_DEFINITION_REQUEST";
export const SAVE_WORKLIST_DEFINITION_SUCCESS =
  "SAVE_WORKLIST_DEFINITION_SUCCESS";
export const SAVE_WORKLIST_DEFINITION_FAILURE =
  "SAVE_WORKLIST_DEFINITION_FAILURE";

export const DELETE_WORKLIST_DEFINITION_REQUEST =
  "DELETE_WORKLIST_DEFINITION_REQUEST";
export const DELETE_WORKLIST_DEFINITION_SUCCESS =
  "DELETE_WORKLIST_DEFINITION_SUCCESS";
export const DELETE_WORKLIST_DEFINITION_FAILURE =
  "DELETE_WORKLIST_DEFINITION_FAILURE";

export const ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_REQUEST =
  "ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_REQUEST";
export const ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_SUCCESS =
  "ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_SUCCESS";
export const ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_FAILURE =
  "ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_FAILURE";

export const FETCH_WORKLIST_GROUP_REQUEST = "FETCH_WORKLIST_GROUP_REQUEST";
export const FETCH_WORKLIST_GROUP_SUCCESS = "FETCH_WORKLIST_GROUP_SUCCESS";
export const FETCH_WORKLIST_GROUP_FAILURE = "FETCH_WORKLIST_GROUP_FAILURE";

export const DROPDOWN_WORKLIST_GROUP_WORKLIST_REQUEST =
  "DROPDOWN_WORKLIST_GROUP_WORKLIST_REQUEST";
export const DROPDOWN_WORKLIST_GROUP_WORKLIST_SUCCESS =
  "DROPDOWN_WORKLIST_GROUP_WORKLIST_SUCCESS";
export const DROPDOWN_WORKLIST_GROUP_WORKLIST_FAILURE =
  "DROPDOWN_WORKLIST_GROUP_WORKLIST_FAILURE";

export const SAVE_WORKLIST_GROUP_REQUEST = "SAVE_WORKLIST_GROUP_REQUEST";
export const SAVE_WORKLIST_GROUP_SUCCESS = "SAVE_WORKLIST_GROUP_SUCCESS";
export const SAVE_WORKLIST_GROUP_FAILURE = "SAVE_WORKLIST_GROUP_FAILURE";

export const DELETE_WORKLIST_GROUP_REQUEST = "DELETE_WORKLIST_GROUP_REQUEST";
export const DELETE_WORKLIST_GROUP_SUCCESS = "DELETE_WORKLIST_GROUP_SUCCESS";
export const DELETE_WORKLIST_GROUP_FAILURE = "DELETE_WORKLIST_GROUP_FAILURE";

export const ACTIVATE_DEACTIVATE_WORKLIST_GROUP_REQUEST =
  "ACTIVATE_DEACTIVATE_WORKLIST_GROUP_REQUEST";
export const ACTIVATE_DEACTIVATE_WORKLIST_GROUP_SUCCESS =
  "ACTIVATE_DEACTIVATE_WORKLIST_GROUP_SUCCESS";
export const ACTIVATE_DEACTIVATE_WORKLIST_GROUP_FAILURE =
  "ACTIVATE_DEACTIVATE_WORKLIST_GROUP_FAILURE";

export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_REQUEST =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_REQUEST";
export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS";
export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_FAILURE =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_FAILURE";

export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_REQUEST =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_REQUEST";
export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_SUCCESS =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_SUCCESS";
export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_FAILURE =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_FAILURE";

export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_REQUEST =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_REQUEST";
export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_SUCCESS =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_SUCCESS";
export const FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_FAILURE =
  "FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_FAILURE";

export const SAVE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST =
  "SAVE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST";
export const SAVE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS =
  "SAVE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS";
export const SAVE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE =
  "SAVE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE";

export const DELETE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST =
  "DELETE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST";
export const DELETE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS =
  "DELETE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS";
export const DELETE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE =
  "DELETE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE";

export const ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST =
  "ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST";
export const ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS =
  "ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS";
export const ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE =
  "ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE";

export const FETCH_TAG_CATEGORY_CONFIGURATION_REQUEST =
  "FETCH_TAG_CATEGORY_CONFIGURATION_REQUEST";
export const FETCH_TAG_CATEGORY_CONFIGURATION_SUCCESS =
  "FETCH_TAG_CATEGORY_CONFIGURATION_SUCCESS";
export const FETCH_TAG_CATEGORY_CONFIGURATION_FAILURE =
  "FETCH_TAG_CATEGORY_CONFIGURATION_FAILURE";

export const FETCH_TAG_CATEGORY_CONFIGURATION_BYID_REQUEST =
  "FETCH_TAG_CATEGORY_CONFIGURATION_BYID_REQUEST";
export const FETCH_TAG_CATEGORY_CONFIGURATION_BYID_SUCCESS =
  "FETCH_TAG_CATEGORY_CONFIGURATION_BYID_SUCCESS";
export const FETCH_TAG_CATEGORY_CONFIGURATION_BYID_FAILURE =
  "FETCH_TAG_CATEGORY_CONFIGURATION_BYID_FAILURE";

export const SAVE_TAG_CATEGORY_CONFIGURATION_REQUEST =
  "SAVE_TAG_CATEGORY_CONFIGURATION_REQUEST";
export const SAVE_TAG_CATEGORY_CONFIGURATION_SUCCESS =
  "SAVE_TAG_CATEGORY_CONFIGURATION_SUCCESS";
export const SAVE_TAG_CATEGORY_CONFIGURATION_FAILURE =
  "SAVE_TAG_CATEGORY_CONFIGURATION_FAILURE";

export const ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_REQUEST =
  "ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_REQUEST";
export const ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_SUCCESS =
  "ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_SUCCESS";
export const ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_FAILURE =
  "ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_FAILURE";

export const FETCH_MANAGE_TAGS_SHELL_REQUEST = "FETCH_MANAGE_TAGS_SHELL_REQUEST";
export const FETCH_MANAGE_TAGS_SHELL_SUCCESS = "FETCH_MANAGE_TAGS_SHELL_SUCCESS";
export const FETCH_MANAGE_TAGS_SHELL_FAILURE = "FETCH_MANAGE_TAGS_SHELL_FAILURE";

export const FETCH_TAG_ASSIGNMENTS_REQUEST = "FETCH_TAG_ASSIGNMENTS_REQUEST";
export const FETCH_TAG_ASSIGNMENTS_SUCCESS = "FETCH_TAG_ASSIGNMENTS_SUCCESS";
export const FETCH_TAG_ASSIGNMENTS_FAILURE = "FETCH_TAG_ASSIGNMENTS_FAILURE";

export const SAVE_MANAGE_TAGS_BATCH_REQUEST = "SAVE_MANAGE_TAGS_BATCH_REQUEST";
export const SAVE_MANAGE_TAGS_BATCH_SUCCESS = "SAVE_MANAGE_TAGS_BATCH_SUCCESS";
export const SAVE_MANAGE_TAGS_BATCH_FAILURE = "SAVE_MANAGE_TAGS_BATCH_FAILURE";

export const SAVE_TAG_REQUEST = "SAVE_TAG_REQUEST";
export const SAVE_TAG_SUCCESS = "SAVE_TAG_SUCCESS";
export const SAVE_TAG_FAILURE = "SAVE_TAG_FAILURE";

export const DELETE_TAG_REQUEST = "DELETE_TAG_REQUEST";
export const DELETE_TAG_SUCCESS = "DELETE_TAG_SUCCESS";
export const DELETE_TAG_FAILURE = "DELETE_TAG_FAILURE";

//-------------dropdowns in Worklist start ----------------

// All master worklist dropdowns
export const DROPDOWN_ALL_MASTER_WORKLIST_REQUEST =
  "DROPDOWN_ALL_MASTER_WORKLIST_REQUEST";
export const DROPDOWN_ALL_MASTER_WORKLIST_SUCCESS =
  "DROPDOWN_ALL_MASTER_WORKLIST_SUCCESS";
export const DROPDOWN_ALL_MASTER_WORKLIST_FAILURE =
  "DROPDOWN_ALL_MASTER_WORKLIST_FAILURE";

// Get Regional Practice Worklist dropdown
export const DROPDOWN_REGIONAL_PRACTICE_WORKLIST_REQUEST =
  "DROPDOWN_REGIONAL_PRACTICE_WORKLIST_REQUEST";
export const DROPDOWN_REGIONAL_PRACTICE_WORKLIST_SUCCESS =
  "DROPDOWN_REGIONAL_PRACTICE_WORKLIST_SUCCESS";
export const DROPDOWN_REGIONAL_PRACTICE_WORKLIST_FAILURE =
  "DROPDOWN_REGIONAL_PRACTICE_WORKLIST_FAILURE";

//Main Practice Dropdown
export const DROPDOWN_MAIN_PRACTICE_REQUEST = "DROPDOWN_MAIN_PRACTICE_REQUEST";
export const DROPDOWN_MAIN_PRACTICE_SUCCESS = "DROPDOWN_MAIN_PRACTICE_SUCCESS";
export const DROPDOWN_MAIN_PRACTICE_FAILURE = "DROPDOWN_MAIN_PRACTICE_FAILURE";

//-------------dropdowns in Worklist end ----------------

// RPCE Action Types
export const FETCH_RPCE_REQUEST = "FETCH_RPCE_REQUEST";
export const FETCH_RPCE_SUCCESS = "FETCH_RPCE_SUCCESS";
export const FETCH_RPCE_FAILURE = "FETCH_RPCE_FAILURE";

export const DELETE_RPCE_REQUEST = "DELETE_RPCE_REQUEST";
export const DELETE_RPCE_SUCCESS = "DELETE_RPCE_SUCCESS";
export const DELETE_RPCE_FAILURE = "DELETE_RPCE_FAILURE";

export const SAVE_RPCE_REQUEST = "SAVE_RPCE_REQUEST";
export const SAVE_RPCE_SUCCESS = "SAVE_RPCE_SUCCESS";
export const SAVE_RPCE_FAILURE = "SAVE_RPCE_FAILURE";

export const FETCH_RPCE_BY_ID_REQUEST = "FETCH_RPCE_BY_ID_REQUEST";
export const FETCH_RPCE_BY_ID_SUCCESS = "FETCH_RPCE_BY_ID_SUCCESS";
export const FETCH_RPCE_BY_ID_FAILURE = "FETCH_RPCE_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_RPCE_REQUEST =
  "ACTIVATE_DEACTIVATE_RPCE_REQUEST";
export const ACTIVATE_DEACTIVATE_RPCE_SUCCESS =
  "ACTIVATE_DEACTIVATE_RPCE_SUCCESS";
export const ACTIVATE_DEACTIVATE_RPCE_FAILURE =
  "ACTIVATE_DEACTIVATE_RPCE_FAILURE";

// Subpractice Action Types
export const FETCH_SUBPRACTICES_REQUEST = "FETCH_SUBPRACTICES_REQUEST";
export const FETCH_SUBPRACTICES_SUCCESS = "FETCH_SUBPRACTICES_SUCCESS";
export const FETCH_SUBPRACTICES_FAILURE = "FETCH_SUBPRACTICES_FAILURE";

export const DELETE_SUBPRACTICE_REQUEST = "DELETE_SUBPRACTICE_REQUEST";
export const DELETE_SUBPRACTICE_SUCCESS = "DELETE_SUBPRACTICE_SUCCESS";
export const DELETE_SUBPRACTICE_FAILURE = "DELETE_SUBPRACTICE_FAILURE";

export const SAVE_SUBPRACTICE_REQUEST = "SAVE_SUBPRACTICE_REQUEST";
export const SAVE_SUBPRACTICE_SUCCESS = "SAVE_SUBPRACTICE_SUCCESS";
export const SAVE_SUBPRACTICE_FAILURE = "SAVE_SUBPRACTICE_FAILURE";

export const FETCH_SUBPRACTICE_BY_ID_REQUEST =
  "FETCH_SUBPRACTICE_BY_ID_REQUEST";
export const FETCH_SUBPRACTICE_BY_ID_SUCCESS =
  "FETCH_SUBPRACTICE_BY_ID_SUCCESS";
export const FETCH_SUBPRACTICE_BY_ID_FAILURE =
  "FETCH_SUBPRACTICE_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_SUBPRACTICE_REQUEST =
  "ACTIVATE_DEACTIVATE_SUBPRACTICE_REQUEST";
export const ACTIVATE_DEACTIVATE_SUBPRACTICE_SUCCESS =
  "ACTIVATE_DEACTIVATE_SUBPRACTICE_SUCCESS";
export const ACTIVATE_DEACTIVATE_SUBPRACTICE_FAILURE =
  "ACTIVATE_DEACTIVATE_SUBPRACTICE_FAILURE";

export const DROPDOWN_SUBPRACTICE_REQUEST = "DROPDOWN_SUBPRACTICE_REQUEST";
export const DROPDOWN_SUBPRACTICE_SUCCESS = "DROPDOWN_SUBPRACTICE_SUCCESS";
export const DROPDOWN_SUBPRACTICE_FAILURE = "DROPDOWN_SUBPRACTICE_FAILURE";

//Practice Action Type
export const FETCH_PRACTICE_REQUEST = "FETCH_PRACTICE_REQUEST";
export const FETCH_PRACTICE_SUCCESS = "FETCH_PRACTICE_SUCCESS";
export const FETCH_PRACTICE_FAILURE = "FETCH_PRACTICE_FAILURE";

export const FETCH_PRACTICE_BY_ID_REQUEST = "FETCH_PRACTICE_BY_ID_REQUEST";
export const FETCH_PRACTICE_BY_ID_SUCCESS = "FETCH_PRACTICE_BY_ID_SUCCESS";
export const FETCH_PRACTICE_BY_ID_FAILURE = "FETCH_PRACTICE_BY_ID_FAILURE";

export const DROPDOWN_WORKLISTDD_REQUEST = "DROPDOWN_WORKLISTDD_REQUEST";
export const DROPDOWN_WORKLISTDD_SUCCESS = "DROPDOWN_WORKLISTDD_SUCCESS";
export const DROPDOWN_WORKLISTDD_FAILURE = "DROPDOWN_WORKLISTDD_FAILURE";

export const DROPDOWN_REGION_BY_WORKLISTID_REQUEST =
  "DROPDOWN_REGION_BY_WORKLISTID_REQUEST";
export const DROPDOWN_REGION_BY_WORKLISTID_SUCCESS =
  "DROPDOWN_REGION_BY_WORKLISTID_SUCCESS";
export const DROPDOWN_REGION_BY_WORKLISTID_FAILURE =
  "DROPDOWN_REGION_BY_WORKLISTID_FAILURE";

export const DROPDOWN_MASTER_REGION_REQUEST =
  "DROPDOWN_MASTER_REGION_REQUEST";
export const DROPDOWN_MASTER_REGION_SUCCESS =
  "DROPDOWN_MASTER_REGION_SUCCESS";
export const DROPDOWN_MASTER_REGION_FAILURE =
  "DROPDOWN_MASTER_REGION_FAILURE";

export const DROPDOWN_MASTER_NATIONAL_REQUEST =
  "DROPDOWN_MASTER_NATIONAL_REQUEST";
export const DROPDOWN_MASTER_NATIONAL_SUCCESS =
  "DROPDOWN_MASTER_NATIONAL_SUCCESS";
export const DROPDOWN_MASTER_NATIONAL_FAILURE =
  "DROPDOWN_MASTER_NATIONAL_FAILURE";

export const SAVE_PRACTICE_REQUEST = "SAVE_PRACTICE_REQUEST";
export const SAVE_PRACTICE_SUCCESS = "SAVE_PRACTICE_SUCCESS";
export const SAVE_PRACTICE_FAILURE = "SAVE_PRACTICE_FAILURE";

export const DELETE_PRACTICE_REQUEST = "DELETE_PRACTICE_REQUEST";
export const DELETE_PRACTICE_SUCCESS = "DELETE_PRACTICE_SUCCESS";
export const DELETE_PRACTICE_FAILURE = "DELETE_PRACTICE_FAILURE";

export const ACTIVATE_DEACTIVATE_PRACTICE_REQUEST =
  "ACTIVATE_DEACTIVATE_PRACTICE_REQUEST";
export const ACTIVATE_DEACTIVATE_PRACTICE_SUCCESS =
  "ACTIVATE_DEACTIVATE_PRACTICE_SUCCESS";
export const ACTIVATE_DEACTIVATE_PRACTICE_FAILURE =
  "ACTIVATE_DEACTIVATE_PRACTICE_FAILURE";

// SectionWorklist Mapping Action Types
export const FETCH_SECTIONWORKLIST_REQUEST = "FETCH_SECTIONWORKLIST_REQUEST";
export const FETCH_SECTIONWORKLIST_SUCCESS = "FETCH_SECTIONWORKLIST_SUCCESS";
export const FETCH_SECTIONWORKLIST_FAILURE = "FETCH_SECTIONWORKLIST_FAILURE";

export const DELETE_SECTIONWORKLIST_REQUEST = "DELETE_SECTIONWORKLIST_REQUEST";
export const DELETE_SECTIONWORKLIST_SUCCESS = "DELETE_SECTIONWORKLIST_SUCCESS";
export const DELETE_SECTIONWORKLIST_FAILURE = "DELETE_SECTIONWORKLIST_FAILURE";

export const SAVE_SECTIONWORKLIST_REQUEST = "SAVE_SECTIONWORKLIST_REQUEST";
export const SAVE_SECTIONWORKLIST_SUCCESS = "SAVE_SECTIONWORKLIST_SUCCESS";
export const SAVE_SECTIONWORKLIST_FAILURE = "SAVE_SECTIONWORKLIST_FAILURE";

export const FETCH_SECTIONWORKLIST_BY_ID_REQUEST =
  "FETCH_SECTIONWORKLIST_BY_ID_REQUEST";
export const FETCH_SECTIONWORKLIST_BY_ID_SUCCESS =
  "FETCH_SECTIONWORKLIST_BY_ID_SUCCESS";
export const FETCH_SECTIONWORKLIST_BY_ID_FAILURE =
  "FETCH_SECTIONWORKLIST_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_SECTIONWORKLIST_REQUEST =
  "ACTIVATE_DEACTIVATE_SECTIONWORKLIST_REQUEST";
export const ACTIVATE_DEACTIVATE_SECTIONWORKLIST_SUCCESS =
  "ACTIVATE_DEACTIVATE_SECTIONWORKLIST_SUCCESS";
export const ACTIVATE_DEACTIVATE_SECTIONWORKLIST_FAILURE =
  "ACTIVATE_DEACTIVATE_SECTIONWORKLIST_FAILURE";

export const DROPDOWN_SECTIONWORKLIST_REQUEST =
  "DROPDOWN_SECTIONWORKLIST_REQUEST";
export const DROPDOWN_SECTIONWORKLIST_SUCCESS =
  "DROPDOWN_SECTIONWORKLIST_SUCCESS";
export const DROPDOWN_SECTIONWORKLIST_FAILURE =
  "DROPDOWN_SECTIONWORKLIST_FAILURE";

// // User Management Mapping Action Types - start
// export const FETCH_USERMANAGEMENT_REQUEST = 'FETCH_USERMANAGEMENT_REQUEST';
// export const FETCH_USERMANAGEMENT_SUCCESS = 'FETCH_USERMANAGEMENT_SUCCESS';
// export const FETCH_USERMANAGEMENT_FAILURE = 'FETCH_USERMANAGEMENT_FAILURE';

// export const DELETE_USERMANAGEMENT_REQUEST = 'DELETE_USERMANAGEMENT_REQUEST';
// export const DELETE_USERMANAGEMENT_SUCCESS = 'DELETE_USERMANAGEMENT_SUCCESS';
// export const DELETE_USERMANAGEMENT_FAILURE = 'DELETE_USERMANAGEMENT_FAILURE';

// export const SAVE_USERMANAGEMENT_REQUEST = 'SAVE_USERMANAGEMENT_REQUEST';
// export const SAVE_USERMANAGEMENT_SUCCESS = 'SAVE_USERMANAGEMENT_SUCCESS';
// export const SAVE_USERMANAGEMENT_FAILURE = 'SAVE_USERMANAGEMENT_FAILURE';

// export const DROPDOWN_USERMANAGEMENTROLE_REQUEST = 'DROPDOWN_USERMANAGEMENTROLE_REQUEST';
// export const DROPDOWN_USERMANAGEMENTROLE_SUCCESS = 'DROPDOWN_USERMANAGEMENTROLE_SUCCESS';
// export const DROPDOWN_USERMANAGEMENTROLE_FAILURE = 'DROPDOWN_USERMANAGEMENTROLE_FAILURE';

// export const DROPDOWN_USERMANAGEMENTDESIGNATION_REQUEST = 'DROPDOWN_USERMANAGEMENTDESIGNATION_REQUEST';
// export const DROPDOWN_USERMANAGEMENTDESIGNATION_SUCCESS = 'DROPDOWN_USERMANAGEMENTDESIGNATION_SUCCESS';
// export const DROPDOWN_USERMANAGEMENTDESIGNATION_FAILURE = 'DROPDOWN_USERMANAGEMENTDESIGNATION_FAILURE';

// export const FETCH_USERMANAGEMENT_BY_ID_REQUEST = 'FETCH_USERMANAGEMENT_BY_ID_REQUEST';
// export const FETCH_USERMANAGEMENT_BY_ID_SUCCESS = 'FETCH_USERMANAGEMENT_BY_ID_SUCCESS';
// export const FETCH_USERMANAGEMENT_BY_ID_FAILURE = 'FETCH_USERMANAGEMENT_BY_ID_FAILURE';

// export const ACTIVATE_DEACTIVATE_USERMANAGEMENT_REQUEST = 'ACTIVATE_DEACTIVATE_USERMANAGEMENT_REQUEST';
// export const ACTIVATE_DEACTIVATE_USERMANAGEMENT_SUCCESS = 'ACTIVATE_DEACTIVATE_USERMANAGEMENT_SUCCESS';
// export const ACTIVATE_DEACTIVATE_USERMANAGEMENT_FAILURE = 'ACTIVATE_DEACTIVATE_USERMANAGEMENT_FAILURE';

// export const DROPDOWN_TENANTS_REQUEST = 'DROPDOWN_TENANTS_REQUEST';
// export const DROPDOWN_TENANTS_SUCCESS = 'DROPDOWN_TENANTS_SUCCESS';
// export const DROPDOWN_TENANTS_FAILURE = 'DROPDOWN_TENANTS_FAILURE';

// export const DROPDOWN_USER_REGIONAL_PRACTICE_REQUEST = 'DROPDOWN_USER_REGIONAL_PRACTICE_REQUEST';
// export const DROPDOWN_USER_REGIONAL_PRACTICE_SUCCESS = 'DROPDOWN_USER_REGIONAL_PRACTICE_SUCCESS';
// export const DROPDOWN_USER_REGIONAL_PRACTICE_FAILURE = 'DROPDOWN_USER_REGIONAL_PRACTICE_FAILURE';

// export const DROPDOWN_USER_MAIN_PRACTICE_REQUEST = 'DROPDOWN_USER_MAIN_PRACTICE_REQUEST';
// export const DROPDOWN_USER_MAIN_PRACTICE_SUCCESS = 'DROPDOWN_USER_MAIN_PRACTICE_SUCCESS';
// export const DROPDOWN_USER_MAIN_PRACTICE_FAILURE = 'DROPDOWN_USER_MAIN_PRACTICE_FAILURE';
// // User Management Mapping Action Types - end

// User Management Mapping Action Types - start
export const FETCH_USERMANAGEMENT_REQUEST = "FETCH_USERMANAGEMENT_REQUEST";
export const FETCH_USERMANAGEMENT_SUCCESS = "FETCH_USERMANAGEMENT_SUCCESS";
export const FETCH_USERMANAGEMENT_FAILURE = "FETCH_USERMANAGEMENT_FAILURE";

export const DELETE_USERMANAGEMENT_REQUEST = "DELETE_USERMANAGEMENT_REQUEST";
export const DELETE_USERMANAGEMENT_SUCCESS = "DELETE_USERMANAGEMENT_SUCCESS";
export const DELETE_USERMANAGEMENT_FAILURE = "DELETE_USERMANAGEMENT_FAILURE";

export const SAVE_USERMANAGEMENT_REQUEST = "SAVE_USERMANAGEMENT_REQUEST";
export const SAVE_USERMANAGEMENT_SUCCESS = "SAVE_USERMANAGEMENT_SUCCESS";
export const SAVE_USERMANAGEMENT_FAILURE = "SAVE_USERMANAGEMENT_FAILURE";

export const FETCH_USERMANAGEMENT_BY_ID_REQUEST =
  "FETCH_USERMANAGEMENT_BY_ID_REQUEST";
export const FETCH_USERMANAGEMENT_BY_ID_SUCCESS =
  "FETCH_USERMANAGEMENT_BY_ID_SUCCESS";
export const FETCH_USERMANAGEMENT_BY_ID_FAILURE =
  "FETCH_USERMANAGEMENT_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_USERMANAGEMENT_REQUEST =
  "ACTIVATE_DEACTIVATE_USERMANAGEMENT_REQUEST";
export const ACTIVATE_DEACTIVATE_USERMANAGEMENT_SUCCESS =
  "ACTIVATE_DEACTIVATE_USERMANAGEMENT_SUCCESS";
export const ACTIVATE_DEACTIVATE_USERMANAGEMENT_FAILURE =
  "ACTIVATE_DEACTIVATE_USERMANAGEMENT_FAILURE";
// User Management Mapping Action Types - end

// Holiday Planner Action Types - start
export const FETCH_HOLIDAY_PLANNER_REQUEST = "FETCH_HOLIDAY_PLANNER_REQUEST";
export const FETCH_HOLIDAY_PLANNER_SUCCESS = "FETCH_HOLIDAY_PLANNER_SUCCESS";
export const FETCH_HOLIDAY_PLANNER_FAILURE = "FETCH_HOLIDAY_PLANNER_FAILURE";

export const ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_REQUEST =
  "ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_REQUEST";
export const ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_SUCCESS =
  "ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_SUCCESS";
export const ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_FAILURE =
  "ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_FAILURE";

export const SAVE_HOLIDAY_PLANNER_REQUEST = "SAVE_HOLIDAY_PLANNER_REQUEST";
export const SAVE_HOLIDAY_PLANNER_SUCCESS = "SAVE_HOLIDAY_PLANNER_SUCCESS";
export const SAVE_HOLIDAY_PLANNER_FAILURE = "SAVE_HOLIDAY_PLANNER_FAILURE";

export const DELETE_HOLIDAY_PLANNER_REQUEST = "DELETE_HOLIDAY_PLANNER_REQUEST";
export const DELETE_HOLIDAY_PLANNER_SUCCESS = "DELETE_HOLIDAY_PLANNER_SUCCESS";
export const DELETE_HOLIDAY_PLANNER_FAILURE = "DELETE_HOLIDAY_PLANNER_FAILURE";

export const HOLIDAY_PLANNER_BULK_UPDATE_REQUEST =
  "HOLIDAY_PLANNER_BULK_UPDATE_REQUEST";
export const HOLIDAY_PLANNER_BULK_UPDATE_SUCCESS =
  "HOLIDAY_PLANNER_BULK_UPDATE_SUCCESS";
export const HOLIDAY_PLANNER_BULK_UPDATE_FAILURE =
  "HOLIDAY_PLANNER_BULK_UPDATE_FAILURE";
// Holiday Planner Action Types - end

//Holiday  Demand Planner Action Types
export const FETCH_HOLIDAY_DEMANDPLANNER_REQUEST =
  "FETCH_HOLIDAY_DEMANDPLANNER_REQUEST";
export const FETCH_HOLIDAY_DEMANDPLANNER_SUCCESS =
  "FETCH_HOLIDAY_DEMANDPLANNER_SUCCESS";
export const FETCH_HOLIDAY_DEMANDPLANNER_FAILURE =
  "FETCH_HOLIDAY_DEMANDPLANNER_FAILURE";

export const Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST =
  "Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST";
export const Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS =
  "Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS";
export const Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE =
  "Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE";
// Bulk Save Holiday Demand Planner
export const BULK_SAVE_HOLIDAY_DEMANDPLANNER_REQUEST =
  "BULK_SAVE_HOLIDAY_DEMANDPLANNER_REQUEST";
export const BULK_SAVE_HOLIDAY_DEMANDPLANNER_SUCCESS =
  "BULK_SAVE_HOLIDAY_DEMANDPLANNER_SUCCESS";
export const BULK_SAVE_HOLIDAY_DEMANDPLANNER_FAILURE =
  "BULK_SAVE_HOLIDAY_DEMANDPLANNER_FAILURE";

export const FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_REQUEST =
  "FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_REQUEST";
export const FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_SUCCESS =
  "FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_SUCCESS";
export const FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_FAILURE =
  "FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_FAILURE";

export const FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_REQUEST =
  "FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_REQUEST";
export const FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_SUCCESS =
  "FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_SUCCESS";
export const FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_FAILURE =
  "FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_FAILURE";

export const FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_REQUEST =
  "FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_REQUEST";
export const FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_SUCCESS =
  "FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_SUCCESS";
export const FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_FAILURE =
  "FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_FAILURE";

export const UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_REQUEST =
  "UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_REQUEST";
export const UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_SUCCESS =
  "UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_SUCCESS";
export const UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_FAILURE =
  "UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_FAILURE";

export const LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST =
  "LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST";
export const LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS =
  "LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS";
export const LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE =
  "LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE";

export const DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST =
  "DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST";
export const DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS =
  "DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS";
export const DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE =
  "DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE";

//----------Main Practice Action Types start from here----------//
//---------- Main Practice Action Types Start ----------//
export const FETCH_MAIN_PRACTICE_REQUEST = "FETCH_MAIN_PRACTICE_REQUEST";
export const FETCH_MAIN_PRACTICE_SUCCESS = "FETCH_MAIN_PRACTICE_SUCCESS";
export const FETCH_MAIN_PRACTICE_FAILURE = "FETCH_MAIN_PRACTICE_FAILURE";

export const FETCH_MAIN_PRACTICE_DROPDOWNLIST_REQUEST =
  "FETCH_MAIN_PRACTICE_DROPDOWNLIST_REQUEST";
export const FETCH_MAIN_PRACTICE_DROPDOWNLIST_SUCCESS =
  "FETCH_MAIN_PRACTICE_DROPDOWNLIST_SUCCESS";
export const FETCH_MAIN_PRACTICE_DROPDOWNLIST_FAILURE =
  "FETCH_MAIN_PRACTICE_DROPDOWNLIST_FAILURE";
//---------- Main Practice Action Types End ----------//

//---------- Regional Practice Worklist ActionType - start ----------//
export const FETCH_REGIONAL_PRACTICE_WORKLIST_REQUEST =
  "FETCH_REGIONAL_PRACTICE_WORKLIST_REQUEST";
export const FETCH_REGIONAL_PRACTICE_WORKLIST_SUCCESS =
  "FETCH_REGIONAL_PRACTICE_WORKLIST_SUCCESS";
export const FETCH_REGIONAL_PRACTICE_WORKLIST_FAILURE =
  "FETCH_REGIONAL_PRACTICE_WORKLIST_FAILURE";

export const DELETE_REGIONAL_PRACTICE_WORKLIST_REQUEST =
  "DELETE_REGIONAL_PRACTICE_WORKLIST_REQUEST";
export const DELETE_REGIONAL_PRACTICE_WORKLIST_SUCCESS =
  "DELETE_REGIONAL_PRACTICE_WORKLIST_SUCCESS";
export const DELETE_REGIONAL_PRACTICE_WORKLIST_FAILURE =
  "DELETE_REGIONAL_PRACTICE_WORKLIST_FAILURE";

export const SAVE_REGIONAL_PRACTICE_WORKLIST_REQUEST =
  "SAVE_REGIONAL_PRACTICE_WORKLIST_REQUEST";
export const SAVE_REGIONAL_PRACTICE_WORKLIST_SUCCESS =
  "SAVE_REGIONAL_PRACTICE_WORKLIST_SUCCESS";
export const SAVE_REGIONAL_PRACTICE_WORKLIST_FAILURE =
  "SAVE_REGIONAL_PRACTICE_WORKLIST_FAILURE";

export const FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_REQUEST =
  "FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_REQUEST";
export const FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_SUCCESS =
  "FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_SUCCESS";
export const FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_FAILURE =
  "FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_REQUEST =
  "ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_REQUEST";
export const ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_SUCCESS =
  "ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_SUCCESS";
export const ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_FAILURE =
  "ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_FAILURE";

export const DROPDOWN_REGIONAL_PRACTICE_REQUEST =
  "DROPDOWN_REGIONAL_PRACTICE_REQUEST";
export const DROPDOWN_REGIONAL_PRACTICE_SUCCESS =
  "DROPDOWN_REGIONAL_PRACTICE_SUCCESS";
export const DROPDOWN_REGIONAL_PRACTICE_FAILURE =
  "DROPDOWN_REGIONAL_PRACTICE_FAILURE";
//---------- RegionalbPracticebWorklist ActionType - end ----------//

//---------- Regional Practice Action Types - start ----------//
export const FETCH_REGIONAL_PRACTICE_REQUEST =
  "FETCH_REGIONAL_PRACTICE_REQUEST";
export const FETCH_REGIONAL_PRACTICE_SUCCESS =
  "FETCH_REGIONAL_PRACTICE_SUCCESS";
export const FETCH_REGIONAL_PRACTICE_FAILURE =
  "FETCH_REGIONAL_PRACTICE_FAILURE";

export const DELETE_REGIONAL_PRACTICE_REQUEST =
  "DELETE_REGIONAL_PRACTICE_REQUEST";
export const DELETE_REGIONAL_PRACTICE_SUCCESS =
  "DELETE_REGIONAL_PRACTICE_SUCCESS";
export const DELETE_REGIONAL_PRACTICE_FAILURE =
  "DELETE_REGIONAL_PRACTICE_FAILURE";

export const SAVE_REGIONAL_PRACTICE_REQUEST = "SAVE_REGIONAL_PRACTICE_REQUEST";
export const SAVE_REGIONAL_PRACTICE_SUCCESS = "SAVE_REGIONAL_PRACTICE_SUCCESS";
export const SAVE_REGIONAL_PRACTICE_FAILURE = "SAVE_REGIONAL_PRACTICE_FAILURE";

export const FETCH_REGIONAL_PRACTICE_BY_ID_REQUEST =
  "FETCH_REGIONAL_PRACTICE_BY_ID_REQUEST";
export const FETCH_REGIONAL_PRACTICE_BY_ID_SUCCESS =
  "FETCH_REGIONAL_PRACTICE_BY_ID_SUCCESS";
export const FETCH_REGIONAL_PRACTICE_BY_ID_FAILURE =
  "FETCH_REGIONAL_PRACTICE_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_REQUEST =
  "ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_REQUEST";
export const ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_SUCCESS =
  "ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_SUCCESS";
export const ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_FAILURE =
  "ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_FAILURE";
//---------- Regional Practice Action Types - end ----------//

export const SAVE_MAIN_PRACTICE_REQUEST = "SAVE_MAIN_PRACTICE_REQUEST";
export const SAVE_MAIN_PRACTICE_SUCCESS = "SAVE_MAIN_PRACTICE_SUCCESS";
export const SAVE_MAIN_PRACTICE_FAILURE = "SAVE_MAIN_PRACTICE_FAILURE";

export const GET_MAIN_PRACTICE_BY_ID_REQUEST =
  "GET_MAIN_PRACTICE_BY_ID_REQUEST";
export const GET_MAIN_PRACTICE_BY_ID_SUCCESS =
  "GET_MAIN_PRACTICE_BY_ID_SUCCESS";
export const GET_MAIN_PRACTICE_BY_ID_FAILURE =
  "GET_MAIN_PRACTICE_BY_ID_FAILURE";

export const DELETE_MAIN_PRACTICE_REQUEST = "DELETE_MAIN_PRACTICE_REQUEST";
export const DELETE_MAIN_PRACTICE_SUCCESS = "DELETE_MAIN_PRACTICE_SUCCESS";
export const DELETE_MAIN_PRACTICE_FAILURE = "DELETE_MAIN_PRACTICE_FAILURE";

export const ACTIVATE_DEACTIVATE_MAIN_PRACTICE_REQUEST =
  "ACTIVATE_DEACTIVATE_MAIN_PRACTICE_REQUEST";
export const ACTIVATE_DEACTIVATE_MAIN_PRACTICE_SUCCESS =
  "ACTIVATE_DEACTIVATE_MAIN_PRACTICE_SUCCESS";
export const ACTIVATE_DEACTIVATE_MAIN_PRACTICE_FAILURE =
  "ACTIVATE_DEACTIVATE_MAIN_PRACTICE_FAILURE";
//----------Main Practice Action Types end here----------//

export const UPDATE_ADMIN_REDUCER = "UPDATE_ADMIN_REDUCER";

// WorkList with PracticeMode (atomic save)
export const SAVE_WORKLIST_FULL_REQUEST = "SAVE_WORKLIST_FULL_REQUEST";
export const SAVE_WORKLIST_FULL_SUCCESS = "SAVE_WORKLIST_FULL_SUCCESS";
export const SAVE_WORKLIST_FULL_FAILURE = "SAVE_WORKLIST_FULL_FAILURE";
